// // import React, { useEffect, useMemo, useState } from 'react';
// // import Select from 'react-select';
// // import { useTranslation } from 'react-i18next';
// // import { Link } from 'react-router-dom';
// // import Loading from '@components/Shared/Loader/Loading';
// // import { Card, CardFooter, CardHeader } from '@components/card/card';

// // import { useAppDispatch, useAppSelector } from '@store/hooks';
// // import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';

// // import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
// // import ReportPagination from '@Helper/ReportPaged/ReportPagination';

// // import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// // import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

// // /** =========================
// //  * ROW
// //  * ========================= */
// // type RowDto = {
// //   transactioN_ID: string | null;
// //   code: string | null;
// //   transactioN_DATE: string | null;

// //   tranS_TYPE_ID: string | null;

// //   vat: number;
// //   neT_AMOUNT: number;
// //   totaL_BEFORE_VAT: number;
// //   discounT_AMOUNT: number; // ✅ العمود الجديد

// //   brancH_ID: string | null;
// //   brancH_NAME: string | null;
// //   brancH_NAME2: string | null;

// //   supplieR_ID: string | null;
// //   supP_NAME: string | null;
// // };

// // const REPORT_KEY = 'RPT_PurchaseDetails';
// // const ENDPOINT = 'FinReports/GetPurchaseDetails';

// // const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

// // const formatNumber = (num: number | null | undefined, digits: number = 2) => {
// //   if (num === null || num === undefined) return '0.00';
// //   return new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
// //     num || 0
// //   );
// // };

// // const formatDate = (dateString: string | null) => {
// //   if (!dateString) return '—';
// //   const d = new Date(dateString);
// //   return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
// // };

// // const isoOrNull = (d: any) => {
// //   if (!d) return null;
// //   if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
// //   if (d instanceof Date) return d.toISOString();
// //   return null;
// // };

// // const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
// //   const out: any = {};
// //   for (const [k, v] of Object.entries(obj)) {
// //     if (v === null || v === undefined || v === '') continue;
// //     out[k] = v; // keep 0/false
// //   }
// //   return out;
// // };

// // const getOptId = (opt: any): string | null => {
// //   const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
// //   return v ? String(v) : null;
// // };

// // const metaNum = (v: any) => {
// //   const n = Number(v);
// //   return Number.isFinite(n) ? n : 0;
// // };

// // const optionsTransType = [
// //   {
// //     value: '3172F5DE-D4D0-4617-8719-18707B69085C',
// //     label: 'مردودات مشتريات أمر شراء'
// //   },
// //   {
// //     value: '969F72DB-35B8-47E2-882C-99AAA5DE4AF1',
// //     label: 'أمر شراء'
// //   },
// //   {
// //     value: '117D4A43-E16C-4057-86F9-C47DC54FD856',
// //     label: 'مردودات مشتريات'
// //   }
// // ];

// // const PurchaseDetails_Paged: React.FC = () => {
// //   const { t, i18n } = useTranslation();
// //   const isAr = i18n.language !== 'en';

// //   const dispatch = useAppDispatch();

// //   // Branch options
// //   const branchHook = useGetOperatingUnitWithPermission() as any;
// //   const OptionsBranches = branchHook?.OperatingUnitOptions ?? branchHook?.OptionsBranches ?? [];
// //   const loadingBranches = branchHook?.loading ?? false;

// //   // Supplier options
// //   const suppHook = useGetSuppliersList() as any;
// //   const OptionsSuppliers = suppHook?.OptionSuppliers ?? suppHook?.OptionsSuppliers ?? suppHook?.options ?? [];
// //   const loadingSuppliers = suppHook?.loading ?? false;

// //   // Filters
// //   const [branchFilter, setBranchFilter] = useState<any>(null);
// //   const [supplierFilter, setSupplierFilter] = useState<any>(null);
// //   const [transTypeId, setTransTypeId] = useState<string>('');
// //   const [fromDate, setFromDate] = useState<any>(null);
// //   const [toDate, setToDate] = useState<any>(null);
// //   const [hasDiscountFilter, setHasDiscountFilter] = useState<any>(null);
// //   const [showExport, setShowExport] = useState(false);

// //   // report state
// //   const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
// //   const items = (report?.items ?? []) as RowDto[];
// //   const meta = report?.meta ?? null;
// //   const loading = report?.loading ?? false;
// //   const error = report?.error ?? null;

// //   // ✅ إضافة عمود الخصم للإكسيل
// //   const exportColumns: ExportColumn<RowDto>[] = [
// //     { headerAr: 'التاريخ', headerEn: 'Date', value: r => formatDate(r.transactioN_DATE) },
// //     { headerAr: 'الكود', headerEn: 'Code', value: r => r.code || '' },
// //     {
// //       headerAr: 'الفرع',
// //       headerEn: 'Branch',
// //       value: r => (isAr ? r.brancH_NAME2 || r.brancH_NAME : r.brancH_NAME || r.brancH_NAME2) || ''
// //     },
// //     { headerAr: 'المورد', headerEn: 'Supplier', value: r => r.supP_NAME || '' },
// //     { headerAr: 'قبل الضريبة', headerEn: 'Before VAT', value: r => r.totaL_BEFORE_VAT || 0 },
// //     { headerAr: 'الخصم', headerEn: 'Discount', value: r => r.discounT_AMOUNT || 0 },
// //     { headerAr: 'الضريبة', headerEn: 'VAT', value: r => r.vat || 0 },
// //     { headerAr: 'الصافي', headerEn: 'Net Amount', value: r => r.neT_AMOUNT || 0 }
// //   ];

// //   const getCodeLink = (code: string | null, id: string | null) => {
// //     if (!code) return null;

// //     if (code.startsWith('RTP')) {
// //       return `/PUR/ReturnsPurchase/AddUpdateReturnsPurchase/${id}`;
// //     }
// //     if (code.startsWith('PO0')) {
// //       return `/PUR/PurchaseOrder/${id}/UpdatePurchaseOrder`;
// //     }
// //     if (code.startsWith('RPO')) {
// //       return `/PUR/ReturnsPurchase-Order/${id}/AddUpdateViewPurchaseReturn`;
// //     }

// //     return null;
// //   };

// //   useEffect(() => {
// //     const initialRequest = {
// //       pageIndex: 0,
// //       pageSize: 50
// //     };

// //     dispatch(
// //       initReport({
// //         reportKey: REPORT_KEY,
// //         endpoint: ENDPOINT,
// //         initialRequest
// //       })
// //     );
// //   }, [dispatch]);

// //   const applyFilters = () => {
// //     const branchId = getOptId(branchFilter);
// //     const supplierId = getOptId(supplierFilter);
// //     const fd = isoOrNull(fromDate);
// //     const td = isoOrNull(toDate);

// //     // استخراج قيمة الخصم (true أو false أو undefined)
// //     const hasDiscountVal = hasDiscountFilter ? hasDiscountFilter.value : undefined;

// //     const prevReq = (((report as any)?.request ?? {}) as any) || {};

// //     const nextReq = {
// //       ...prevReq,
// //       pageIndex: 0,
// //       pageSize: prevReq.pageSize ?? 50,
// //       froM_DATE: fd,
// //       tO_DATE: td,
// //       brancH_ID: branchId,
// //       supplieR_ID: supplierId,
// //       tranS_TYPE_ID: transTypeId || null,
// //       haS_DISCOUNT: hasDiscountVal // ✅ إرسال القيمة (true, false, undefined)
// //     };

// //     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
// //     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
// //   };

// //   const clearFilters = () => {
// //     // 1. تصفير الحالات المحلية
// //     setBranchFilter(null);
// //     setSupplierFilter(null);
// //     setTransTypeId('');
// //     setFromDate(null);
// //     setToDate(null);
// //     setHasDiscountFilter(null); // ✅ تصفير الفلتر الجديد
// //     // 2. تصفير الـ Request
// //     const resetReq = {
// //       pageIndex: 0,
// //       pageSize: 50,
// //     //   fromDate: undefined,
// //     //   toDate: undefined,
// //     //   branchId: undefined,
// //     //   supplierId: undefined,
// //     //   transTypeId: undefined,
// //       haS_DISCOUNT: undefined, // ✅ إزالة الفلتر

// //       froM_DATE: undefined,
// //       tO_DATE: undefined,
// //       brancH_ID: undefined,
// //       tranS_TYPE_ID: undefined,
// //       supplieR_ID: undefined
// //     };

// //     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
// //     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
// //   };

// //   const TotalsCards = () => {
// //     if (!meta) return null;

// //     const totalBeforeVat = metaNum((meta as any).total_TOTAL_BEFORE_VAT);
// //     const totalVat = metaNum((meta as any).total_VAT);
// //     const totalNet = metaNum((meta as any).total_NET_AMOUNT);
// //     const total_DIS = metaNum((meta as any).total_DISCOUNT);

// //     const hasAny = totalBeforeVat !== 0 || totalVat !== 0 || totalNet !== 0;
// //     if (!hasAny && items.length === 0) return null;

// //     return (
// //       <div className='row g-3 mb-3'>
// //         <div className='col-lg-3 col-md-6'>
// //           <Card className='card bg-primary bg-opacity-10 border-0 shadow-sm h-100'>
// //             <div className='card-body d-flex align-items-center'>
// //               <div className='p-3 me-3'>
// //                 <i className='fas fa-receipt text-primary fa-xl'></i>
// //               </div>
// //               <div>
// //                 <h6 className='text-primary fw-bold mb-1'>{isAr ? 'إجمالي قبل الضريبة' : 'Total Before VAT'}</h6>
// //                 <h4 className='mb-0 fw-bold'>{formatNumber(totalBeforeVat)}</h4>
// //               </div>
// //             </div>
// //           </Card>
// //         </div>

// //         <div className='col-lg-3 col-md-6'>
// //           <Card className='card bg-warning bg-opacity-10 border-0 shadow-sm h-100'>
// //             <div className='card-body d-flex align-items-center'>
// //               <div className='p-3 me-3'>
// //                 <i className='fas fa-percent text-warning fa-xl'></i>
// //               </div>
// //               <div>
// //                 <h6 className='text-warning fw-bold mb-1'>{isAr ? 'إجمالي الضريبة' : 'Total VAT'}</h6>
// //                 <h4 className='mb-0 fw-bold'>{formatNumber(totalVat)}</h4>
// //               </div>
// //             </div>
// //           </Card>
// //         </div>

// //         <div className='col-lg-3 col-md-6'>
// //           <Card className='card bg-success bg-opacity-10 border-0 shadow-sm h-100'>
// //             <div className='card-body d-flex align-items-center'>
// //               <div className='p-3 me-3'>
// //                 <i className='fas fa-coins text-success fa-xl'></i>
// //               </div>
// //               <div>
// //                 <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي الصافي' : 'Total Net Amount'}</h6>
// //                 <h4 className='mb-0 fw-bold'>{formatNumber(totalNet)}</h4>
// //               </div>
// //             </div>
// //           </Card>
// //         </div>
// //         <div className='col-lg-3 col-md-6'>
// //           <Card className='card bg-success bg-opacity-10 border-0 shadow-sm h-100'>
// //             <div className='card-body d-flex align-items-center'>
// //               <div className='p-3 me-3'>
// //                 <i className='fas fa-coins text-success fa-xl'></i>
// //               </div>
// //               <div>
// //                 <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي الخصومات' : 'Total Discount'}</h6>
// //                 <h4 className='mb-0 fw-bold'>{formatNumber(total_DIS)}</h4>
// //               </div>
// //             </div>
// //           </Card>
// //         </div>
// //       </div>
// //     );
// //   };

// //   // ✅ إضافة الخصم إلى المجموع أسفل الجدول
// //   const totalsFooter = useMemo(() => {
// //     return items.reduce(
// //       (acc, r) => {
// //         acc.totalBeforeVat += r.totaL_BEFORE_VAT || 0;
// //         acc.totalDiscount += r.discounT_AMOUNT || 0; // ✅
// //         acc.totalVat += r.vat || 0;
// //         acc.totalNet += r.neT_AMOUNT || 0;
// //         return acc;
// //       },
// //       { totalBeforeVat: 0, totalDiscount: 0, totalVat: 0, totalNet: 0 }
// //     );
// //   }, [items]);

// //   return (
// //     <>
// //       <CardHeader className='mb-3'>
// //         <div className='row g-2 align-items-center mb-2'>
// //           {/* Branch */}
// //           <div className='col-lg-3'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-store text-primary'></i>
// //               </span>
// //               <Select
// //                 isLoading={loadingBranches}
// //                 value={branchFilter}
// //                 onChange={setBranchFilter}
// //                 options={OptionsBranches}
// //                 placeholder={isAr ? 'الفرع' : 'Branch'}
// //                 isClearable
// //                 isSearchable
// //                 className='flex-grow-1'
// //                 classNamePrefix='react-select'
// //                 menuPortalTarget={document.body}
// //                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
// //               />
// //             </div>
// //           </div>

// //           {/* Supplier */}
// //           <div className='col-lg-3'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-truck text-danger'></i>
// //               </span>
// //               <Select
// //                 isLoading={loadingSuppliers}
// //                 value={supplierFilter}
// //                 onChange={setSupplierFilter}
// //                 options={OptionsSuppliers}
// //                 placeholder={isAr ? 'المورد' : 'Supplier'}
// //                 isClearable
// //                 isSearchable
// //                 className='flex-grow-1'
// //                 classNamePrefix='react-select'
// //                 menuPortalTarget={document.body}
// //                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
// //               />
// //             </div>
// //           </div>

// //           {/* From */}
// //           <div className='col-lg-2'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-calendar'></i>
// //               </span>
// //               <input
// //                 type='date'
// //                 className='form-control'
// //                 value={fromDate || ''}
// //                 onChange={e => setFromDate(e.target.value)}
// //                 placeholder={isAr ? 'من تاريخ' : 'From Date'}
// //               />
// //             </div>
// //           </div>

// //           {/* To */}
// //           <div className='col-lg-2'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-calendar'></i>
// //               </span>
// //               <input
// //                 type='date'
// //                 className='form-control'
// //                 value={toDate || ''}
// //                 onChange={e => setToDate(e.target.value)}
// //                 min={fromDate || undefined}
// //                 placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
// //               />
// //             </div>
// //           </div>

// //           {/* Buttons */}
// //           <div className='col-lg-2 text-end'>
// //             <button
// //               className='btn btn-outline-secondary me-2'
// //               type='button'
// //               onClick={clearFilters}
// //               title={t('ClearFilters')}
// //             >
// //               <i className='fas fa-times fa-fw'></i>
// //             </button>

// //             <button className='btn btn-theme me-2' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
// //               <i className='fas fa-filter fa-fw'></i>
// //             </button>

// //             <button
// //               className='btn btn-outline-success'
// //               type='button'
// //               onClick={() => setShowExport(true)}
// //               title={t('Export')}
// //               disabled={loading || items.length === 0}
// //             >
// //               <i className='fas fa-file-excel fa-fw'></i>
// //             </button>
// //           </div>
// //         </div>

// //         <div className='row g-2 align-items-center'>
// //           {/* Trans Type Id */}
// //           <div className='col-lg-4'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-tags text-warning'></i>
// //               </span>
// //               <Select
// //                 value={optionsTransType.find(f => f.value === transTypeId)}
// //                 options={optionsTransType}
// //                 onChange={(op: any) => setTransTypeId(op === null ? null : op.value)}
// //                 placeholder={isAr ? 'نوع الحركة' : 'Trans Type'}
// //                 isClearable
// //                 isSearchable
// //                 className='flex-grow-1'
// //                 classNamePrefix='react-select'
// //                 menuPortalTarget={document.body}
// //                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
// //               />
// //             </div>
// //           </div>

// //           {/* ✅ سويتش الفلتر الجديد: يوجد خصم */}
// //           <div className='col-lg-3'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-percent text-danger'></i>
// //               </span>
// //               <Select
// //                 value={hasDiscountFilter}
// //                 onChange={setHasDiscountFilter}
// //                 options={[
// //                   { value: true, label: isAr ? 'يوجد خصم' : 'Has Discount' },
// //                   { value: false, label: isAr ? 'لا يوجد خصم' : 'No Discount' }
// //                 ]}
// //                 placeholder={isAr ? 'حالة الخصم (الكل)' : 'Discount Status (All)'}
// //                 isClearable // ✅ هذا ما يسمح بالحالة الثالثة (تفريغ الفلتر ليعود null)
// //                 isSearchable={false}
// //                 className='flex-grow-1'
// //                 classNamePrefix='react-select'
// //                 menuPortalTarget={document.body}
// //                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </CardHeader>

// //       <TotalsCards />

// //       <Card className='mb-4'>
// //         <Loading loading={loading} error={error}>
// //           <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
// //             <table className='table table-hover table-bordered mb-0'>
// //               <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
// //                 <tr className='bg-theme bg-opacity-35 text-center' style={{ backdropFilter: 'blur(20px)' }}>
// //                   <th className='small text-primary' colSpan={4}>
// //                     {isAr ? 'بيانات العملية' : 'Transaction Info'}
// //                   </th>
// //                   {/* ✅ تعديل دمج الأعمدة ليتناسب مع إضافة عمود الخصم (أصبحوا 4 بدلاً من 3) */}
// //                   <th className='small text-success' colSpan={4}>
// //                     {isAr ? 'المبالغ' : 'Amounts'}
// //                   </th>
// //                 </tr>

// //                 <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
// //                   <th className='small' style={{ minWidth: 130 }}>
// //                     {t('Date')}
// //                   </th>
// //                   <th className='small' style={{ minWidth: 160 }}>
// //                     {isAr ? 'الكود' : 'Code'}
// //                   </th>
// //                   <th className='small' style={{ minWidth: 170 }}>
// //                     {isAr ? 'الفرع' : 'Branch'}
// //                   </th>
// //                   <th className='small' style={{ minWidth: 220 }}>
// //                     {isAr ? 'المورد' : 'Supplier'}
// //                   </th>
// //                   <th className='small text-end' style={{ minWidth: 120 }}>
// //                     {isAr ? 'قبل الضريبة' : 'Before VAT'}
// //                   </th>
// //                   <th className='small text-end' style={{ minWidth: 100 }}>
// //                     {isAr ? 'الخصم' : 'Discount'}
// //                   </th>{' '}
// //                   {/* ✅ العمود الجديد */}
// //                   <th className='small text-end' style={{ minWidth: 110 }}>
// //                     {isAr ? 'الضريبة' : 'VAT'}
// //                   </th>
// //                   <th className='small text-end' style={{ minWidth: 120 }}>
// //                     {isAr ? 'الصافي' : 'Net Amount'}
// //                   </th>
// //                 </tr>
// //               </thead>

// //               <tbody>
// //                 {!loading && items.length > 0 ? (
// //                   items.map((r, idx) => {
// //                     const branchName = isAr ? r.brancH_NAME2 || r.brancH_NAME : r.brancH_NAME || r.brancH_NAME2;

// //                     return (
// //                       <tr key={`${r.transactioN_ID || idx}`} className='align-middle'>
// //                         <td className='text-center'>{formatDate(r.transactioN_DATE)}</td>
// //                         <td className='text-center'>
// //                           {(() => {
// //                             const linkUrl = getCodeLink(r.code, r.transactioN_ID);

// //                             return linkUrl ? (
// //                               <Link to={linkUrl} className='fw-bold text-primary text-decoration-none' target='_blank'>
// //                                 {safe(r.code)}
// //                               </Link>
// //                             ) : (
// //                               <span className='fw-bold text-primary'>{safe(r.code)}</span>
// //                             );
// //                           })()}
// //                         </td>
// //                         <td className='text-start'>{safe(branchName)}</td>
// //                         <td className='text-start'>{safe(r.supP_NAME)}</td>

// //                         <td className='text-end fw-bold'>{formatNumber(r.totaL_BEFORE_VAT)}</td>
// //                         {/* ✅ عرض قيمة الخصم */}
// //                         <td className='text-end fw-bold text-danger'>{formatNumber(r.discounT_AMOUNT)}</td>
// //                         <td className='text-end fw-bold text-warning'>{formatNumber(r.vat)}</td>
// //                         <td className='text-end fw-bold text-success'>{formatNumber(r.neT_AMOUNT)}</td>
// //                       </tr>
// //                     );
// //                   })
// //                 ) : !loading ? (
// //                   <tr>
// //                     <td colSpan={8} className='text-center py-5'>
// //                       {' '}
// //                       {/* ✅ تغيير colSpan إلى 8 */}
// //                       <div className='text-muted'>
// //                         <i className='fas fa-file-invoice fa-3x mb-3 opacity-50'></i>
// //                         <h6>{t('NoData')}</h6>
// //                       </div>
// //                     </td>
// //                   </tr>
// //                 ) : null}
// //               </tbody>

// //               {!loading && items.length > 0 && (
// //                 <tfoot className='fw-bold bg-secondary bg-opacity-30'>
// //                   <tr>
// //                     <td colSpan={4} className='text-end'>
// //                       <span className='h6 m-0'>{isAr ? 'الإجمالي (الصفحة):' : 'Totals (page):'}</span>
// //                     </td>
// //                     <td className='text-end'>
// //                       <span className='h6 m-0'>{formatNumber(totalsFooter.totalBeforeVat)}</span>
// //                     </td>
// //                     {/* ✅ إضافة مجموع الخصم */}
// //                     <td className='text-end text-danger'>
// //                       <span className='h6 m-0'>{formatNumber(totalsFooter.totalDiscount)}</span>
// //                     </td>
// //                     <td className='text-end text-warning'>
// //                       <span className='h6 m-0'>{formatNumber(totalsFooter.totalVat)}</span>
// //                     </td>
// //                     <td className='text-end text-success'>
// //                       <span className='h6 m-0'>{formatNumber(totalsFooter.totalNet)}</span>
// //                     </td>
// //                   </tr>
// //                 </tfoot>
// //               )}
// //             </table>
// //           </div>
// //         </Loading>

// //         <CardFooter>
// //           <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
// //             <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />
// //           </div>
// //         </CardFooter>
// //       </Card>

// //       <ReportExportExcelModal
// //         show={showExport}
// //         onHide={() => setShowExport(false)}
// //         reportKey={REPORT_KEY}
// //         endpoint={ENDPOINT}
// //         columns={exportColumns}
// //         exportPageSize={4000}
// //         sheetName={({ isAr }) => (isAr ? 'تفاصيل المشتريات' : 'Purchase Details')}
// //         fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
// //       />
// //     </>
// //   );
// // };

// // export default PurchaseDetails_Paged;

// // import React, { useEffect, useMemo, useState } from 'react';
// // import Select from 'react-select';
// // import { useTranslation } from 'react-i18next';
// // import { Link } from 'react-router-dom';
// // import Loading from '@components/Shared/Loader/Loading';
// // import { Card, CardFooter, CardHeader } from '@components/card/card';

// // import { useAppDispatch, useAppSelector } from '@store/hooks';
// // import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';

// // import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
// // import ReportPagination from '@Helper/ReportPaged/ReportPagination';

// // import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// // import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

// // /** =========================
// //  * ROW
// //  * ========================= */
// // type RowDto = {
// //   transactioN_ID: string | null;
// //   code: string | null;
// //   transactioN_DATE: string | null;

// //   tranS_TYPE_ID: string | null;

// //   vat: number;
// //   neT_AMOUNT: number;
// //   totaL_BEFORE_VAT: number;
// //   discounT_AMOUNT: number; // ✅ العمود الجديد

// //   brancH_ID: string | null;
// //   brancH_NAME: string | null;
// //   brancH_NAME2: string | null;

// //   supplieR_ID: string | null;
// //   supP_NAME: string | null;
// //   vaT_CODE: string | null;
// // };

// // const REPORT_KEY = 'RPT_PurchaseDetails';
// // const ENDPOINT = 'FinReports/GetPurchaseDetails';

// // const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

// // const formatNumber = (num: number | null | undefined, digits: number = 2) => {
// //   if (num === null || num === undefined) return '0.00';
// //   return new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
// //     num || 0
// //   );
// // };

// // const formatDate = (dateString: string | null) => {
// //   if (!dateString) return '—';
// //   const d = new Date(dateString);
// //   return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
// // };

// // const isoOrNull = (d: any) => {
// //   if (!d) return null;
// //   if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
// //   if (d instanceof Date) return d.toISOString();
// //   return null;
// // };

// // const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
// //   const out: any = {};
// //   for (const [k, v] of Object.entries(obj)) {
// //     if (v === null || v === undefined || v === '') continue;
// //     out[k] = v; // keep 0/false
// //   }
// //   return out;
// // };

// // const getOptId = (opt: any): string | null => {
// //   const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
// //   return v ? String(v) : null;
// // };

// // const metaNum = (v: any) => {
// //   const n = Number(v);
// //   return Number.isFinite(n) ? n : 0;
// // };

// // const optionsTransType = [
// //   {
// //     value: '3172F5DE-D4D0-4617-8719-18707B69085C',
// //     label: 'مردودات مشتريات أمر شراء'
// //   },
// //   {
// //     value: '969F72DB-35B8-47E2-882C-99AAA5DE4AF1',
// //     label: 'أمر شراء'
// //   },
// //   {
// //     value: '117D4A43-E16C-4057-86F9-C47DC54FD856',
// //     label: 'مردودات مشتريات'
// //   },
// //   // الخيار الجديد
// //   {
// //     value: 'RETURN_ONLY_TRIGGER', // قيمة مميزة للتعرف عليها عند الفلترة
// //     label: 'جميع المردودات'
// //   }
// // ];

// // const PurchaseDetails_Paged: React.FC = () => {
// //   const { t, i18n } = useTranslation();
// //   const isAr = i18n.language !== 'en';

// //   const dispatch = useAppDispatch();

// //   // Branch options
// //   const branchHook = useGetOperatingUnitWithPermission() as any;
// //   const OptionsBranches = branchHook?.OperatingUnitOptions ?? branchHook?.OptionsBranches ?? [];
// //   const loadingBranches = branchHook?.loading ?? false;

// //   // Supplier options
// //   const suppHook = useGetSuppliersList() as any;
// //   const OptionsSuppliers = suppHook?.OptionSuppliers ?? suppHook?.OptionsSuppliers ?? suppHook?.options ?? [];
// //   const loadingSuppliers = suppHook?.loading ?? false;

// //   // Filters
// //   const [branchFilter, setBranchFilter] = useState<any>(null);
// //   const [supplierFilter, setSupplierFilter] = useState<any>(null);
// //   const [transTypeId, setTransTypeId] = useState<string>('');
// //   const [fromDate, setFromDate] = useState<any>(null);
// //   const [toDate, setToDate] = useState<any>(null);
// //   const [hasDiscountFilter, setHasDiscountFilter] = useState<any>(null);
// //   const [showExport, setShowExport] = useState(false);

// //   // report state
// //   const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
// //   const items = (report?.items ?? []) as RowDto[];
// //   const meta = report?.meta ?? null;
// //   const loading = report?.loading ?? false;
// //   const error = report?.error ?? null;

// //   // ✅ إضافة عمود الخصم للإكسيل
// //   const exportColumns: ExportColumn<RowDto>[] = [
// //     { headerAr: 'التاريخ', headerEn: 'Date', value: r => formatDate(r.transactioN_DATE) },
// //     { headerAr: 'الكود', headerEn: 'Code', value: r => r.code || '' },
// //     {
// //       headerAr: 'الفرع',
// //       headerEn: 'Branch',
// //       value: r => (isAr ? r.brancH_NAME2 || r.brancH_NAME : r.brancH_NAME || r.brancH_NAME2) || ''
// //     },
// //     { headerAr: 'المورد', headerEn: 'Supplier', value: r => r.supP_NAME || '' },
// //     { headerAr: 'الرقم الضريبي', headerEn: 'Vat Code', value: r => r.vaT_CODE || '' },
// //     { headerAr: 'قبل الضريبة', headerEn: 'Before VAT', value: r => r.totaL_BEFORE_VAT || 0 },
// //     { headerAr: 'الخصم', headerEn: 'Discount', value: r => r.discounT_AMOUNT || 0 },
// //     { headerAr: 'الضريبة', headerEn: 'VAT', value: r => r.vat || 0 },
// //     { headerAr: 'الصافي', headerEn: 'Net Amount', value: r => r.neT_AMOUNT || 0 }
// //   ];

// //   const getCodeLink = (code: string | null, id: string | null) => {
// //     if (!code) return null;

// //     if (code.startsWith('RTP')) {
// //       return `/PUR/ReturnsPurchase/AddUpdateReturnsPurchase/${id}`;
// //     }
// //     if (code.startsWith('PO0')) {
// //       return `/PUR/PurchaseOrder/${id}/UpdatePurchaseOrder`;
// //     }
// //     if (code.startsWith('RPO')) {
// //       return `/PUR/ReturnsPurchase-Order/${id}/AddUpdateViewPurchaseReturn`;
// //     }

// //     return null;
// //   };

// //   useEffect(() => {
// //     const initialRequest = {
// //       pageIndex: 0,
// //       pageSize: 50
// //     };

// //     dispatch(
// //       initReport({
// //         reportKey: REPORT_KEY,
// //         endpoint: ENDPOINT,
// //         initialRequest
// //       })
// //     );
// //   }, [dispatch]);

// //   //   const applyFilters = () => {
// //   //     const branchId = getOptId(branchFilter);
// //   //     const supplierId = getOptId(supplierFilter);
// //   //     const fd = isoOrNull(fromDate);
// //   //     const td = isoOrNull(toDate);

// //   //     // استخراج قيمة الخصم (true أو false أو undefined)
// //   //     const hasDiscountVal = hasDiscountFilter ? hasDiscountFilter.value : undefined;

// //   //     const prevReq = (((report as any)?.request ?? {}) as any) || {};

// //   //     const nextReq = {
// //   //       ...prevReq,
// //   //       pageIndex: 0,
// //   //       pageSize: prevReq.pageSize ?? 50,
// //   //       froM_DATE: fd,
// //   //       tO_DATE: td,
// //   //       brancH_ID: branchId,
// //   //       supplieR_ID: supplierId,
// //   //       tranS_TYPE_ID: transTypeId || null,
// //   //       haS_DISCOUNT: hasDiscountVal // ✅ إرسال القيمة (true, false, undefined)
// //   //     };

// //   //     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
// //   //     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
// //   //   };

// //   const applyFilters = () => {
// //     const branchId = getOptId(branchFilter);
// //     const supplierId = getOptId(supplierFilter);
// //     const fd = isoOrNull(fromDate);
// //     const td = isoOrNull(toDate);

// //     const hasDiscountVal = hasDiscountFilter ? hasDiscountFilter.value : undefined;

// //     // التحقق مما إذا كان المختار هو "جميع المردودات"
// //     const isReturnOnly = transTypeId === 'RETURN_ONLY_TRIGGER';

// //     const prevReq = (((report as any)?.request ?? {}) as any) || {};

// //     var nextReq;

// //     if (isReturnOnly) {
// //       nextReq = {
// //         ...prevReq,
// //         pageIndex: 0,
// //         pageSize: prevReq.pageSize ?? 50,
// //         froM_DATE: fd,
// //         tO_DATE: td,
// //         brancH_ID: branchId,
// //         supplieR_ID: supplierId,

// //         tranS_TYPE_ID: undefined,

// //         onlY_RETURN: true,
// //         haS_DISCOUNT: hasDiscountVal
// //       };
// //     } else {
// //       nextReq = {
// //         ...prevReq,
// //         pageIndex: 0,
// //         pageSize: prevReq.pageSize ?? 50,
// //         froM_DATE: fd,
// //         tO_DATE: td,
// //         brancH_ID: branchId,
// //         supplieR_ID: supplierId,
// //         tranS_TYPE_ID: transTypeId || null,
// //         haS_DISCOUNT: hasDiscountVal
// //       };
// //     }

// //     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
// //     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
// //   };

// //   const clearFilters = () => {
// //     setBranchFilter(null);
// //     setSupplierFilter(null);
// //     setTransTypeId('');
// //     setFromDate(null);
// //     setToDate(null);
// //     setHasDiscountFilter(null);

// //     const resetReq = {
// //       pageIndex: 0,
// //       pageSize: 50,
// //       haS_DISCOUNT: undefined,
// //       froM_DATE: undefined,
// //       tO_DATE: undefined,
// //       brancH_ID: undefined,
// //       tranS_TYPE_ID: undefined,
// //       supplieR_ID: undefined,
// //       onlY_RETURN: undefined // ✅ تصفير فلتر المردودات
// //     };

// //     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
// //     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
// //   };
// //   const TotalsCards = () => {
// //     if (!meta) return null;

// //     const totalBeforeVat = metaNum((meta as any).total_TOTAL_BEFORE_VAT);
// //     const totalVat = metaNum((meta as any).total_VAT);
// //     const totalNet = metaNum((meta as any).total_NET_AMOUNT);
// //     const total_DIS = metaNum((meta as any).total_DISCOUNT);

// //     const hasAny = totalBeforeVat !== 0 || totalVat !== 0 || totalNet !== 0;
// //     if (!hasAny && items.length === 0) return null;

// //     return (
// //       <div className='row g-3 mb-3'>
// //         <div className='col-lg-3 col-md-6'>
// //           <Card className='card bg-primary bg-opacity-10 border-0 shadow-sm h-100'>
// //             <div className='card-body d-flex align-items-center'>
// //               <div className='p-3 me-3'>
// //                 <i className='fas fa-receipt text-primary fa-xl'></i>
// //               </div>
// //               <div>
// //                 <h6 className='text-primary fw-bold mb-1'>{isAr ? 'إجمالي قبل الضريبة' : 'Total Before VAT'}</h6>
// //                 <h4 className='mb-0 fw-bold'>{formatNumber(totalBeforeVat)}</h4>
// //               </div>
// //             </div>
// //           </Card>
// //         </div>

// //         <div className='col-lg-3 col-md-6'>
// //           <Card className='card bg-warning bg-opacity-10 border-0 shadow-sm h-100'>
// //             <div className='card-body d-flex align-items-center'>
// //               <div className='p-3 me-3'>
// //                 <i className='fas fa-percent text-warning fa-xl'></i>
// //               </div>
// //               <div>
// //                 <h6 className='text-warning fw-bold mb-1'>{isAr ? 'إجمالي الضريبة' : 'Total VAT'}</h6>
// //                 <h4 className='mb-0 fw-bold'>{formatNumber(totalVat)}</h4>
// //               </div>
// //             </div>
// //           </Card>
// //         </div>

// //         <div className='col-lg-3 col-md-6'>
// //           <Card className='card bg-success bg-opacity-10 border-0 shadow-sm h-100'>
// //             <div className='card-body d-flex align-items-center'>
// //               <div className='p-3 me-3'>
// //                 <i className='fas fa-coins text-success fa-xl'></i>
// //               </div>
// //               <div>
// //                 <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي الصافي' : 'Total Net Amount'}</h6>
// //                 <h4 className='mb-0 fw-bold'>{formatNumber(totalNet)}</h4>
// //               </div>
// //             </div>
// //           </Card>
// //         </div>
// //         <div className='col-lg-3 col-md-6'>
// //           <Card className='card bg-success bg-opacity-10 border-0 shadow-sm h-100'>
// //             <div className='card-body d-flex align-items-center'>
// //               <div className='p-3 me-3'>
// //                 <i className='fas fa-coins text-success fa-xl'></i>
// //               </div>
// //               <div>
// //                 <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي الخصومات' : 'Total Discount'}</h6>
// //                 <h4 className='mb-0 fw-bold'>{formatNumber(total_DIS)}</h4>
// //               </div>
// //             </div>
// //           </Card>
// //         </div>
// //       </div>
// //     );
// //   };

// //   // ✅ إضافة الخصم إلى المجموع أسفل الجدول
// //   const totalsFooter = useMemo(() => {
// //     return items.reduce(
// //       (acc, r) => {
// //         acc.totalBeforeVat += r.totaL_BEFORE_VAT || 0;
// //         acc.totalDiscount += r.discounT_AMOUNT || 0; // ✅
// //         acc.totalVat += r.vat || 0;
// //         acc.totalNet += r.neT_AMOUNT || 0;
// //         return acc;
// //       },
// //       { totalBeforeVat: 0, totalDiscount: 0, totalVat: 0, totalNet: 0 }
// //     );
// //   }, [items]);

// //   return (
// //     <>
// //       <CardHeader className='mb-3'>
// //         <div className='row g-2 align-items-center mb-2'>
// //           {/* Branch */}
// //           <div className='col-lg-3'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-store text-primary'></i>
// //               </span>
// //               <Select
// //                 isLoading={loadingBranches}
// //                 value={branchFilter}
// //                 onChange={setBranchFilter}
// //                 options={OptionsBranches}
// //                 placeholder={isAr ? 'الفرع' : 'Branch'}
// //                 isClearable
// //                 isSearchable
// //                 className='flex-grow-1'
// //                 classNamePrefix='react-select'
// //                 menuPortalTarget={document.body}
// //                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
// //               />
// //             </div>
// //           </div>

// //           {/* Supplier */}
// //           <div className='col-lg-3'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-truck text-danger'></i>
// //               </span>
// //               <Select
// //                 isLoading={loadingSuppliers}
// //                 value={supplierFilter}
// //                 onChange={setSupplierFilter}
// //                 options={OptionsSuppliers}
// //                 placeholder={isAr ? 'المورد' : 'Supplier'}
// //                 isClearable
// //                 isSearchable
// //                 className='flex-grow-1'
// //                 classNamePrefix='react-select'
// //                 menuPortalTarget={document.body}
// //                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
// //               />
// //             </div>
// //           </div>

// //           {/* From */}
// //           <div className='col-lg-2'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-calendar'></i>
// //               </span>
// //               <input
// //                 type='date'
// //                 className='form-control'
// //                 value={fromDate || ''}
// //                 onChange={e => setFromDate(e.target.value)}
// //                 placeholder={isAr ? 'من تاريخ' : 'From Date'}
// //               />
// //             </div>
// //           </div>

// //           {/* To */}
// //           <div className='col-lg-2'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-calendar'></i>
// //               </span>
// //               <input
// //                 type='date'
// //                 className='form-control'
// //                 value={toDate || ''}
// //                 onChange={e => setToDate(e.target.value)}
// //                 min={fromDate || undefined}
// //                 placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
// //               />
// //             </div>
// //           </div>

// //           {/* Buttons */}
// //           <div className='col-lg-2 text-end'>
// //             <button
// //               className='btn btn-outline-secondary me-2'
// //               type='button'
// //               onClick={clearFilters}
// //               title={t('ClearFilters')}
// //             >
// //               <i className='fas fa-times fa-fw'></i>
// //             </button>

// //             <button className='btn btn-theme me-2' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
// //               <i className='fas fa-filter fa-fw'></i>
// //             </button>

// //             <button
// //               className='btn btn-outline-success'
// //               type='button'
// //               onClick={() => setShowExport(true)}
// //               title={t('Export')}
// //               disabled={loading || items.length === 0}
// //             >
// //               <i className='fas fa-file-excel fa-fw'></i>
// //             </button>
// //           </div>
// //         </div>

// //         <div className='row g-2 align-items-center'>
// //           {/* Trans Type Id */}
// //           <div className='col-lg-4'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-tags text-warning'></i>
// //               </span>
// //               <Select
// //                 value={optionsTransType.find(f => f.value === transTypeId)}
// //                 options={optionsTransType}
// //                 onChange={(op: any) => setTransTypeId(op === null ? null : op.value)}
// //                 placeholder={isAr ? 'نوع الحركة' : 'Trans Type'}
// //                 isClearable
// //                 isSearchable
// //                 className='flex-grow-1'
// //                 classNamePrefix='react-select'
// //                 menuPortalTarget={document.body}
// //                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
// //               />
// //             </div>
// //           </div>

// //           {/* ✅ سويتش الفلتر الجديد: يوجد خصم */}
// //           <div className='col-lg-3'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-percent text-danger'></i>
// //               </span>
// //               <Select
// //                 value={hasDiscountFilter}
// //                 onChange={setHasDiscountFilter}
// //                 options={[
// //                   { value: true, label: isAr ? 'يوجد خصم' : 'Has Discount' },
// //                   { value: false, label: isAr ? 'لا يوجد خصم' : 'No Discount' }
// //                 ]}
// //                 placeholder={isAr ? 'حالة الخصم (الكل)' : 'Discount Status (All)'}
// //                 isClearable // ✅ هذا ما يسمح بالحالة الثالثة (تفريغ الفلتر ليعود null)
// //                 isSearchable={false}
// //                 className='flex-grow-1'
// //                 classNamePrefix='react-select'
// //                 menuPortalTarget={document.body}
// //                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </CardHeader>

// //       <TotalsCards />

// //       <Card className='mb-4'>
// //         <Loading loading={loading} error={error}>
// //           <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
// //             <table className='table table-hover table-bordered mb-0'>
// //               <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
// //                 <tr className='bg-theme bg-opacity-35 text-center' style={{ backdropFilter: 'blur(20px)' }}>
// //                   <th className='small text-primary' colSpan={4}>
// //                     {isAr ? 'بيانات العملية' : 'Transaction Info'}
// //                   </th>
// //                   {/* ✅ تعديل دمج الأعمدة ليتناسب مع إضافة عمود الخصم (أصبحوا 4 بدلاً من 3) */}
// //                   <th className='small text-success' colSpan={4}>
// //                     {isAr ? 'المبالغ' : 'Amounts'}
// //                   </th>
// //                 </tr>

// //                 <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
// //                   <th className='small' style={{ minWidth: 130 }}>
// //                     {t('Date')}
// //                   </th>
// //                   <th className='small' style={{ minWidth: 160 }}>
// //                     {isAr ? 'الكود' : 'Code'}
// //                   </th>
// //                   <th className='small' style={{ minWidth: 170 }}>
// //                     {isAr ? 'الفرع' : 'Branch'}
// //                   </th>
// //                   <th className='small' style={{ minWidth: 220 }}>
// //                     {isAr ? 'المورد' : 'Supplier'}
// //                   </th>
// //                   <th className='small text-end' style={{ minWidth: 120 }}>
// //                     {isAr ? 'قبل الضريبة' : 'Before VAT'}
// //                   </th>
// //                   <th className='small text-end' style={{ minWidth: 100 }}>
// //                     {isAr ? 'الخصم' : 'Discount'}
// //                   </th>{' '}
// //                   {/* ✅ العمود الجديد */}
// //                   <th className='small text-end' style={{ minWidth: 110 }}>
// //                     {isAr ? 'الضريبة' : 'VAT'}
// //                   </th>
// //                   <th className='small text-end' style={{ minWidth: 120 }}>
// //                     {isAr ? 'الصافي' : 'Net Amount'}
// //                   </th>
// //                 </tr>
// //               </thead>

// //               <tbody>
// //                 {!loading && items.length > 0 ? (
// //                   items.map((r, idx) => {
// //                     const branchName = isAr ? r.brancH_NAME2 || r.brancH_NAME : r.brancH_NAME || r.brancH_NAME2;

// //                     return (
// //                       <tr key={`${r.transactioN_ID || idx}`} className='align-middle'>
// //                         <td className='text-center'>{formatDate(r.transactioN_DATE)}</td>
// //                         <td className='text-center'>
// //                           {(() => {
// //                             const linkUrl = getCodeLink(r.code, r.transactioN_ID);

// //                             return linkUrl ? (
// //                               <Link to={linkUrl} className='fw-bold text-primary text-decoration-none' target='_blank'>
// //                                 {safe(r.code)}
// //                               </Link>
// //                             ) : (
// //                               <span className='fw-bold text-primary'>{safe(r.code)}</span>
// //                             );
// //                           })()}
// //                         </td>
// //                         <td className='text-start'>{safe(branchName)}</td>
// //                         <td className='text-start'>
// //                           <span className='fw-bold'>{safe(r.supP_NAME)}</span>
// //                           <br />
// //                           {safe(r.vaT_CODE)}
// //                         </td>

// //                         <td className='text-end fw-bold'>{formatNumber(r.totaL_BEFORE_VAT)}</td>
// //                         {/* ✅ عرض قيمة الخصم */}
// //                         <td className='text-end fw-bold text-danger'>{formatNumber(r.discounT_AMOUNT)}</td>
// //                         <td className='text-end fw-bold text-warning'>{formatNumber(r.vat)}</td>
// //                         <td className='text-end fw-bold text-success'>{formatNumber(r.neT_AMOUNT)}</td>
// //                       </tr>
// //                     );
// //                   })
// //                 ) : !loading ? (
// //                   <tr>
// //                     <td colSpan={8} className='text-center py-5'>
// //                       {' '}
// //                       {/* ✅ تغيير colSpan إلى 8 */}
// //                       <div className='text-muted'>
// //                         <i className='fas fa-file-invoice fa-3x mb-3 opacity-50'></i>
// //                         <h6>{t('NoData')}</h6>
// //                       </div>
// //                     </td>
// //                   </tr>
// //                 ) : null}
// //               </tbody>

// //               {!loading && items.length > 0 && (
// //                 <tfoot className='fw-bold bg-secondary bg-opacity-30'>
// //                   <tr>
// //                     <td colSpan={4} className='text-end'>
// //                       <span className='h6 m-0'>{isAr ? 'الإجمالي (الصفحة):' : 'Totals (page):'}</span>
// //                     </td>
// //                     <td className='text-end'>
// //                       <span className='h6 m-0'>{formatNumber(totalsFooter.totalBeforeVat)}</span>
// //                     </td>
// //                     {/* ✅ إضافة مجموع الخصم */}
// //                     <td className='text-end text-danger'>
// //                       <span className='h6 m-0'>{formatNumber(totalsFooter.totalDiscount)}</span>
// //                     </td>
// //                     <td className='text-end text-warning'>
// //                       <span className='h6 m-0'>{formatNumber(totalsFooter.totalVat)}</span>
// //                     </td>
// //                     <td className='text-end text-success'>
// //                       <span className='h6 m-0'>{formatNumber(totalsFooter.totalNet)}</span>
// //                     </td>
// //                   </tr>
// //                 </tfoot>
// //               )}
// //             </table>
// //           </div>
// //         </Loading>

// //         <CardFooter>
// //           <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
// //             <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />
// //           </div>
// //         </CardFooter>
// //       </Card>

// //       <ReportExportExcelModal
// //         show={showExport}
// //         onHide={() => setShowExport(false)}
// //         reportKey={REPORT_KEY}
// //         endpoint={ENDPOINT}
// //         columns={exportColumns}
// //         exportPageSize={4000}
// //         sheetName={({ isAr }) => (isAr ? 'تفاصيل المشتريات' : 'Purchase Details')}
// //         fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
// //       />
// //     </>
// //   );
// // };

// // export default PurchaseDetails_Paged;


// import React, { useEffect, useMemo, useState } from 'react';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';
// import { Card, CardFooter, CardHeader } from '@components/card/card';

// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';

// import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
// import ReportPagination from '@Helper/ReportPaged/ReportPagination';

// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

// /** =========================
//  * ROW
//  * ========================= */
// type RowDto = {
//   transactioN_ID: string | null;
//   code: string | null;
//   transactioN_DATE: string | null;

//   tranS_TYPE_ID: string | null;

//   vat: number;
//   neT_AMOUNT: number;
//   totaL_BEFORE_VAT: number;
//   discounT_AMOUNT: number;

//   brancH_ID: string | null;
//   brancH_NAME: string | null;
//   brancH_NAME2: string | null;

//   supplieR_ID: string | null;
//   supP_NAME: string | null;
//   vaT_CODE: string | null;
// };

// const REPORT_KEY = 'RPT_PurchaseDetails';
// const ENDPOINT = 'FinReports/GetPurchaseDetails';

// const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

// const formatNumber = (num: number | null | undefined, digits: number = 2) => {
//   if (num === null || num === undefined) return '0.00';
//   return new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
//     num || 0
//   );
// };

// const formatDate = (dateString: string | null) => {
//   if (!dateString) return '—';
//   const d = new Date(dateString);
//   return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
// };

// const isoOrNull = (d: any) => {
//   if (!d) return null;
//   if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
//   if (d instanceof Date) return d.toISOString();
//   return null;
// };

// const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
//   const out: any = {};
//   for (const [k, v] of Object.entries(obj)) {
//     if (v === null || v === undefined || v === '') continue;
//     out[k] = v; // keep 0/false
//   }
//   return out;
// };

// const getOptId = (opt: any): string | null => {
//   const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
//   return v ? String(v) : null;
// };

// const metaNum = (v: any) => {
//   const n = Number(v);
//   return Number.isFinite(n) ? n : 0;
// };

// const optionsTransType = [
//   {
//     value: '3172F5DE-D4D0-4617-8719-18707B69085C',
//     label: 'مردودات مشتريات أمر شراء'
//   },
//   {
//     value: '969F72DB-35B8-47E2-882C-99AAA5DE4AF1',
//     label: 'أمر شراء'
//   },
//   {
//     value: '117D4A43-E16C-4057-86F9-C47DC54FD856',
//     label: 'مردودات مشتريات'
//   },
//   {
//     value: 'RETURN_ONLY_TRIGGER',
//     label: 'جميع المردودات'
//   }
// ];

// const PurchaseDetails_Paged: React.FC = () => {
//   const { t, i18n } = useTranslation();
//   const isAr = i18n.language !== 'en';

//   const dispatch = useAppDispatch();

//   // Branch options
//   const branchHook = useGetOperatingUnitWithPermission() as any;
//   const OptionsBranches = branchHook?.OperatingUnitOptions ?? branchHook?.OptionsBranches ?? [];
//   const loadingBranches = branchHook?.loading ?? false;

//   // Supplier options
//   const suppHook = useGetSuppliersList() as any;
//   const OptionsSuppliers = suppHook?.OptionSuppliers ?? suppHook?.OptionsSuppliers ?? suppHook?.options ?? [];
//   const loadingSuppliers = suppHook?.loading ?? false;

//   // Filters
//   const [branchFilter, setBranchFilter] = useState<any>(null);
//   const [supplierFilter, setSupplierFilter] = useState<any>(null);
//   const [transTypeId, setTransTypeId] = useState<string>('');
//   const [fromDate, setFromDate] = useState<any>(null);
//   const [toDate, setToDate] = useState<any>(null);
//   const [hasDiscountFilter, setHasDiscountFilter] = useState<any>(null);
  
//   // ✅ ستيت الفلتر الجديد (حالة الضريبة)
//   const [vatModeFilter, setVatModeFilter] = useState<any>(null);
  
//   const [showExport, setShowExport] = useState(false);

//   // report state
//   const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
//   const items = (report?.items ?? []) as RowDto[];
//   const meta = report?.meta ?? null;
//   const loading = report?.loading ?? false;
//   const error = report?.error ?? null;

//   const exportColumns: ExportColumn<RowDto>[] = [
//     { headerAr: 'التاريخ', headerEn: 'Date', value: r => formatDate(r.transactioN_DATE) },
//     { headerAr: 'الكود', headerEn: 'Code', value: r => r.code || '' },
//     {
//       headerAr: 'الفرع',
//       headerEn: 'Branch',
//       value: r => (isAr ? r.brancH_NAME2 || r.brancH_NAME : r.brancH_NAME || r.brancH_NAME2) || ''
//     },
//     { headerAr: 'المورد', headerEn: 'Supplier', value: r => r.supP_NAME || '' },
//     { headerAr: 'الرقم الضريبي', headerEn: 'Vat Code', value: r => r.vaT_CODE || '' },
//     { headerAr: 'قبل الضريبة', headerEn: 'Before VAT', value: r => r.totaL_BEFORE_VAT || 0 },
//     { headerAr: 'الخصم', headerEn: 'Discount', value: r => r.discounT_AMOUNT || 0 },
//     { headerAr: 'الضريبة', headerEn: 'VAT', value: r => r.vat || 0 },
//     { headerAr: 'الصافي', headerEn: 'Net Amount', value: r => r.neT_AMOUNT || 0 }
//   ];

//   const getCodeLink = (code: string | null, id: string | null) => {
//     if (!code) return null;

//     if (code.startsWith('RTP')) {
//       return `/PUR/ReturnsPurchase/AddUpdateReturnsPurchase/${id}`;
//     }
//     if (code.startsWith('PO0')) {
//       return `/PUR/PurchaseOrder/${id}/UpdatePurchaseOrder`;
//     }
//     if (code.startsWith('RPO')) {
//       return `/PUR/ReturnsPurchase-Order/${id}/AddUpdateViewPurchaseReturn`;
//     }

//     return null;
//   };

//   useEffect(() => {
//     const initialRequest = {
//       pageIndex: 0,
//       pageSize: 50
//     };

//     dispatch(
//       initReport({
//         reportKey: REPORT_KEY,
//         endpoint: ENDPOINT,
//         initialRequest
//       })
//     );
//   }, [dispatch]);

//   const applyFilters = () => {
//     const branchId = getOptId(branchFilter);
//     const supplierId = getOptId(supplierFilter);
//     const fd = isoOrNull(fromDate);
//     const td = isoOrNull(toDate);

//     const hasDiscountVal = hasDiscountFilter ? hasDiscountFilter.value : undefined;
    
//     // ✅ استخراج قيمة فلتر الضريبة
//     const vatModeVal = vatModeFilter ? vatModeFilter.value : undefined;

//     const isReturnOnly = transTypeId === 'RETURN_ONLY_TRIGGER';

//     const prevReq = (((report as any)?.request ?? {}) as any) || {};

//     var nextReq;

//     if (isReturnOnly) {
//       nextReq = {
//         ...prevReq,
//         pageIndex: 0,
//         pageSize: prevReq.pageSize ?? 50,
//         froM_DATE: fd,
//         tO_DATE: td,
//         brancH_ID: branchId,
//         supplieR_ID: supplierId,
//         tranS_TYPE_ID: undefined,
//         onlY_RETURN: true,
//         haS_DISCOUNT: hasDiscountVal,
//         vaT_MODE: vatModeVal // ✅ إرسال الفلتر الجديد
//       };
//     } else {
//       nextReq = {
//         ...prevReq,
//         pageIndex: 0,
//         pageSize: prevReq.pageSize ?? 50,
//         froM_DATE: fd,
//         tO_DATE: td,
//         brancH_ID: branchId,
//         supplieR_ID: supplierId,
//         tranS_TYPE_ID: transTypeId || null,
//         haS_DISCOUNT: hasDiscountVal,
//         vaT_MODE: vatModeVal // ✅ إرسال الفلتر الجديد
//       };
//     }

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   const clearFilters = () => {
//     setBranchFilter(null);
//     setSupplierFilter(null);
//     setTransTypeId('');
//     setFromDate(null);
//     setToDate(null);
//     setHasDiscountFilter(null);
//     setVatModeFilter(null); // ✅ تصفير فلتر الضريبة

//     const resetReq = {
//       pageIndex: 0,
//       pageSize: 50,
//       haS_DISCOUNT: undefined,
//       vaT_MODE: undefined, // ✅ تصفير القيمة في الـ Request
//       froM_DATE: undefined,
//       tO_DATE: undefined,
//       brancH_ID: undefined,
//       tranS_TYPE_ID: undefined,
//       supplieR_ID: undefined,
//       onlY_RETURN: undefined
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   const TotalsCards = () => {
//     if (!meta) return null;

//     const totalBeforeVat = metaNum((meta as any).total_TOTAL_BEFORE_VAT);
//     const totalVat = metaNum((meta as any).total_VAT);
//     const totalNet = metaNum((meta as any).total_NET_AMOUNT);
//     const total_DIS = metaNum((meta as any).total_DISCOUNT);

//     const hasAny = totalBeforeVat !== 0 || totalVat !== 0 || totalNet !== 0;
//     if (!hasAny && items.length === 0) return null;

//     return (
//       <div className='row g-3 mb-3'>
//         <div className='col-lg-3 col-md-6'>
//           <Card className='card bg-primary bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-receipt text-primary fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-primary fw-bold mb-1'>{isAr ? 'إجمالي قبل الضريبة' : 'Total Before VAT'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(totalBeforeVat)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>

//         <div className='col-lg-3 col-md-6'>
//           <Card className='card bg-warning bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-percent text-warning fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-warning fw-bold mb-1'>{isAr ? 'إجمالي الضريبة' : 'Total VAT'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(totalVat)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>

//         <div className='col-lg-3 col-md-6'>
//           <Card className='card bg-success bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-coins text-success fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي الصافي' : 'Total Net Amount'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(totalNet)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>
//         <div className='col-lg-3 col-md-6'>
//           <Card className='card bg-success bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-coins text-success fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي الخصومات' : 'Total Discount'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(total_DIS)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>
//       </div>
//     );
//   };

//   const totalsFooter = useMemo(() => {
//     return items.reduce(
//       (acc, r) => {
//         acc.totalBeforeVat += r.totaL_BEFORE_VAT || 0;
//         acc.totalDiscount += r.discounT_AMOUNT || 0;
//         acc.totalVat += r.vat || 0;
//         acc.totalNet += r.neT_AMOUNT || 0;
//         return acc;
//       },
//       { totalBeforeVat: 0, totalDiscount: 0, totalVat: 0, totalNet: 0 }
//     );
//   }, [items]);

//   return (
//     <>
//       <CardHeader className='mb-3'>
//         <div className='row g-2 align-items-center mb-2'>
//           {/* Branch */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-store text-primary'></i>
//               </span>
//               <Select
//                 isLoading={loadingBranches}
//                 value={branchFilter}
//                 onChange={setBranchFilter}
//                 options={OptionsBranches}
//                 placeholder={isAr ? 'الفرع' : 'Branch'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* Supplier */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-truck text-danger'></i>
//               </span>
//               <Select
//                 isLoading={loadingSuppliers}
//                 value={supplierFilter}
//                 onChange={setSupplierFilter}
//                 options={OptionsSuppliers}
//                 placeholder={isAr ? 'المورد' : 'Supplier'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* From */}
//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={fromDate || ''}
//                 onChange={e => setFromDate(e.target.value)}
//                 placeholder={isAr ? 'من تاريخ' : 'From Date'}
//               />
//             </div>
//           </div>

//           {/* To */}
//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={toDate || ''}
//                 onChange={e => setToDate(e.target.value)}
//                 min={fromDate || undefined}
//                 placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
//               />
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className='col-lg-2 text-end'>
//             <button
//               className='btn btn-outline-secondary me-2'
//               type='button'
//               onClick={clearFilters}
//               title={t('ClearFilters')}
//             >
//               <i className='fas fa-times fa-fw'></i>
//             </button>

//             <button className='btn btn-theme me-2' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
//               <i className='fas fa-filter fa-fw'></i>
//             </button>

//             <button
//               className='btn btn-outline-success'
//               type='button'
//               onClick={() => setShowExport(true)}
//               title={t('Export')}
//               disabled={loading || items.length === 0}
//             >
//               <i className='fas fa-file-excel fa-fw'></i>
//             </button>
//           </div>
//         </div>

//         <div className='row g-2 align-items-center'>
//           {/* Trans Type Id */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-tags text-warning'></i>
//               </span>
//               <Select
//                 value={optionsTransType.find(f => f.value === transTypeId)}
//                 options={optionsTransType}
//                 onChange={(op: any) => setTransTypeId(op === null ? null : op.value)}
//                 placeholder={isAr ? 'نوع الحركة' : 'Trans Type'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* Has Discount Filter */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-percent text-danger'></i>
//               </span>
//               <Select
//                 value={hasDiscountFilter}
//                 onChange={setHasDiscountFilter}
//                 options={[
//                   { value: true, label: isAr ? 'يوجد خصم' : 'Has Discount' },
//                   { value: false, label: isAr ? 'لا يوجد خصم' : 'No Discount' }
//                 ]}
//                 placeholder={isAr ? 'حالة الخصم (الكل)' : 'Discount Status (All)'}
//                 isClearable
//                 isSearchable={false}
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* ✅ الفلتر الجديد: نوع الضريبة (شامل / غير شامل) */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-file-invoice-dollar text-primary'></i>
//               </span>
//               <Select
//                 value={vatModeFilter}
//                 onChange={setVatModeFilter}
//                 options={[
//                   { value: true, label: isAr ? ' ضريبية' : 'with VAT ' },
//                   { value: false, label: isAr ? ' غير ضريبية' : 'without VAT ' }
//                 ]}
//                 placeholder={isAr ? 'حالة الضريبة (الكل)' : 'VAT Mode (All)'}
//                 isClearable
//                 isSearchable={false}
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//         </div>
//       </CardHeader>

//       <TotalsCards />

//       <Card className='mb-4'>
//         <Loading loading={loading} error={error}>
//           <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
//             <table className='table table-hover table-bordered mb-0'>
//               <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
//                 <tr className='bg-theme bg-opacity-35 text-center' style={{ backdropFilter: 'blur(20px)' }}>
//                   <th className='small text-primary' colSpan={4}>
//                     {isAr ? 'بيانات العملية' : 'Transaction Info'}
//                   </th>
//                   <th className='small text-success' colSpan={4}>
//                     {isAr ? 'المبالغ' : 'Amounts'}
//                   </th>
//                 </tr>

//                 <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
//                   <th className='small' style={{ minWidth: 130 }}>
//                     {t('Date')}
//                   </th>
//                   <th className='small' style={{ minWidth: 160 }}>
//                     {isAr ? 'الكود' : 'Code'}
//                   </th>
//                   <th className='small' style={{ minWidth: 170 }}>
//                     {isAr ? 'الفرع' : 'Branch'}
//                   </th>
//                   <th className='small' style={{ minWidth: 220 }}>
//                     {isAr ? 'المورد' : 'Supplier'}
//                   </th>
//                   <th className='small text-end' style={{ minWidth: 120 }}>
//                     {isAr ? 'قبل الضريبة' : 'Before VAT'}
//                   </th>
//                   <th className='small text-end' style={{ minWidth: 100 }}>
//                     {isAr ? 'الخصم' : 'Discount'}
//                   </th>
//                   <th className='small text-end' style={{ minWidth: 110 }}>
//                     {isAr ? 'الضريبة' : 'VAT'}
//                   </th>
//                   <th className='small text-end' style={{ minWidth: 120 }}>
//                     {isAr ? 'الصافي' : 'Net Amount'}
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {!loading && items.length > 0 ? (
//                   items.map((r, idx) => {
//                     const branchName = isAr ? r.brancH_NAME2 || r.brancH_NAME : r.brancH_NAME || r.brancH_NAME2;

//                     return (
//                       <tr key={`${r.transactioN_ID || idx}`} className='align-middle'>
//                         <td className='text-center'>{formatDate(r.transactioN_DATE)}</td>
//                         <td className='text-center'>
//                           {(() => {
//                             const linkUrl = getCodeLink(r.code, r.transactioN_ID);

//                             return linkUrl ? (
//                               <Link to={linkUrl} className='fw-bold text-primary text-decoration-none' target='_blank'>
//                                 {safe(r.code)}
//                               </Link>
//                             ) : (
//                               <span className='fw-bold text-primary'>{safe(r.code)}</span>
//                             );
//                           })()}
//                         </td>
//                         <td className='text-start'>{safe(branchName)}</td>
//                         <td className='text-start'>
//                           <span className='fw-bold'>{safe(r.supP_NAME)}</span>
//                           <br />
//                           {safe(r.vaT_CODE)}
//                         </td>

//                         <td className='text-end fw-bold'>{formatNumber(r.totaL_BEFORE_VAT)}</td>
//                         <td className='text-end fw-bold text-danger'>{formatNumber(r.discounT_AMOUNT)}</td>
//                         <td className='text-end fw-bold text-warning'>{formatNumber(r.vat)}</td>
//                         <td className='text-end fw-bold text-success'>{formatNumber(r.neT_AMOUNT)}</td>
//                       </tr>
//                     );
//                   })
//                 ) : !loading ? (
//                   <tr>
//                     <td colSpan={8} className='text-center py-5'>
//                       <div className='text-muted'>
//                         <i className='fas fa-file-invoice fa-3x mb-3 opacity-50'></i>
//                         <h6>{t('NoData')}</h6>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : null}
//               </tbody>

//               {!loading && items.length > 0 && (
//                 <tfoot className='fw-bold bg-secondary bg-opacity-30'>
//                   <tr>
//                     <td colSpan={4} className='text-end'>
//                       <span className='h6 m-0'>{isAr ? 'الإجمالي (الصفحة):' : 'Totals (page):'}</span>
//                     </td>
//                     <td className='text-end'>
//                       <span className='h6 m-0'>{formatNumber(totalsFooter.totalBeforeVat)}</span>
//                     </td>
//                     <td className='text-end text-danger'>
//                       <span className='h6 m-0'>{formatNumber(totalsFooter.totalDiscount)}</span>
//                     </td>
//                     <td className='text-end text-warning'>
//                       <span className='h6 m-0'>{formatNumber(totalsFooter.totalVat)}</span>
//                     </td>
//                     <td className='text-end text-success'>
//                       <span className='h6 m-0'>{formatNumber(totalsFooter.totalNet)}</span>
//                     </td>
//                   </tr>
//                 </tfoot>
//               )}
//             </table>
//           </div>
//         </Loading>

//         <CardFooter>
//           <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
//             <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />
//           </div>
//         </CardFooter>
//       </Card>

//       <ReportExportExcelModal
//         show={showExport}
//         onHide={() => setShowExport(false)}
//         reportKey={REPORT_KEY}
//         endpoint={ENDPOINT}
//         columns={exportColumns}
//         exportPageSize={4000}
//         sheetName={({ isAr }) => (isAr ? 'تفاصيل المشتريات' : 'Purchase Details')}
//         fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
//       />
//     </>
//   );
// };

// export default PurchaseDetails_Paged;


import React, { useEffect, useMemo, useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import { Card, CardFooter, CardHeader } from '@components/card/card';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';

import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
import ReportPagination from '@Helper/ReportPaged/ReportPagination';

import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

/** =========================
 * ROW
 * ========================= */
type RowDto = {
  transactioN_ID: string | null;
  code: string | null;
  transactioN_DATE: string | null;

  tranS_TYPE_ID: string | null;

  vat: number;
  neT_AMOUNT: number;
  totaL_BEFORE_VAT: number;
  discounT_AMOUNT: number;

  brancH_ID: string | null;
  brancH_NAME: string | null;
  brancH_NAME2: string | null;

  supplieR_ID: string | null;
  supP_NAME: string | null;
  vaT_CODE: string | null;
};

type BoolOption = {
  value: boolean;
  label: string;
};

type LookupOption = {
  value: string;
  label: string;
  [key: string]: any;
};

type FiltersState = {
  branch: any | null;
  supplier: any | null;
  transTypeId: string | null;
  fromDate: string;
  toDate: string;
  hasDiscount: BoolOption | null;
  vatMode: BoolOption | null;
};

const REPORT_KEY = 'RPT_PurchaseDetails';
const ENDPOINT = 'FinReports/GetPurchaseDetails';
const RETURN_ONLY_TRIGGER = 'RETURN_ONLY_TRIGGER';

const defaultFilters: FiltersState = {
  branch: null,
  supplier: null,
  transTypeId: null,
  fromDate: '',
  toDate: '',
  hasDiscount: null,
  vatMode: null
};

const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

const formatNumber = (num: number | null | undefined, digits: number = 2) => {
  if (num === null || num === undefined) return '0.00';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(num || 0);
};

const formatDate = (dateString: string | null) => {
  if (!dateString) return '—';
  const d = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(d);
};

const isoOrUndefined = (d?: string | null) => {
  if (!d) return undefined;
  if (/^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
  return undefined;
};

const cleanObject = <T extends Record<string, any>>(obj: T): Partial<T> => {
  const out: Partial<T> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === undefined || v === null || v === '') continue;
    (out as any)[k] = v; // keep false / 0
  }
  return out;
};

const getOptId = (opt: any): string | undefined => {
  const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? undefined;
  return v ? String(v) : undefined;
};

const metaNum = (v: any) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const optionsTransType: LookupOption[] = [
  {
    value: '3172F5DE-D4D0-4617-8719-18707B69085C',
    label: 'مردودات مشتريات أمر شراء'
  },
  {
    value: '969F72DB-35B8-47E2-882C-99AAA5DE4AF1',
    label: 'أمر شراء'
  },
  {
    value: '117D4A43-E16C-4057-86F9-C47DC54FD856',
    label: 'مردودات مشتريات'
  },
  {
    value: RETURN_ONLY_TRIGGER,
    label: 'جميع المردودات'
  }
];

const PurchaseDetails_Paged: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language !== 'en';

  const dispatch = useAppDispatch();

  const branchHook = useGetOperatingUnitWithPermission() as any;
  const OptionsBranches = branchHook?.OperatingUnitOptions ?? branchHook?.OptionsBranches ?? [];
  const loadingBranches = branchHook?.loading ?? false;

  const suppHook = useGetSuppliersList() as any;
  const OptionsSuppliers = suppHook?.OptionSuppliers ?? suppHook?.OptionsSuppliers ?? suppHook?.options ?? [];
  const loadingSuppliers = suppHook?.loading ?? false;

  const [filters, setFilters] = useState<FiltersState>(defaultFilters);
  const [showExport, setShowExport] = useState(false);

  const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
  const items = (report?.items ?? []) as RowDto[];
  const meta = report?.meta ?? null;
  const loading = report?.loading ?? false;
  const error = report?.error ?? null;

  const pageSize = report?.request?.pageSize ?? 50;
  const sortBy = report?.request?.sortBy;
  const sortDir = report?.request?.sortDir;

  const setFilter = <K extends keyof FiltersState>(key: K, value: FiltersState[K]) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const exportColumns: ExportColumn<RowDto>[] = [
    { headerAr: 'التاريخ', headerEn: 'Date', value: r => formatDate(r.transactioN_DATE) },
    { headerAr: 'الكود', headerEn: 'Code', value: r => r.code || '' },
    {
      headerAr: 'الفرع',
      headerEn: 'Branch',
      value: r => (isAr ? r.brancH_NAME2 || r.brancH_NAME : r.brancH_NAME || r.brancH_NAME2) || ''
    },
    { headerAr: 'المورد', headerEn: 'Supplier', value: r => r.supP_NAME || '' },
    { headerAr: 'الرقم الضريبي', headerEn: 'Vat Code', value: r => r.vaT_CODE || '' },
    { headerAr: 'قبل الضريبة', headerEn: 'Before VAT', value: r => r.totaL_BEFORE_VAT || 0 },
    { headerAr: 'الخصم', headerEn: 'Discount', value: r => r.discounT_AMOUNT || 0 },
    { headerAr: 'الضريبة', headerEn: 'VAT', value: r => r.vat || 0 },
    { headerAr: 'الصافي', headerEn: 'Net Amount', value: r => r.neT_AMOUNT || 0 }
  ];

  const getCodeLink = (code: string | null, id: string | null) => {
    if (!code) return null;

    if (code.startsWith('RTP')) {
      return `/PUR/ReturnsPurchase/AddUpdateReturnsPurchase/${id}`;
    }
    if (code.startsWith('PO0')) {
      return `/PUR/PurchaseOrder/${id}/UpdatePurchaseOrder`;
    }
    if (code.startsWith('RPO')) {
      return `/PUR/ReturnsPurchase-Order/${id}/AddUpdateViewPurchaseReturn`;
    }

    return null;
  };

  useEffect(() => {
    dispatch(
      initReport({
        reportKey: REPORT_KEY,
        endpoint: ENDPOINT,
        initialRequest: {
          pageIndex: 0,
          pageSize: 50
        }
      })
    );
  }, [dispatch]);

  const buildRequestFromFilters = (f: FiltersState) => {
    const branchId = getOptId(f.branch);
    const supplierId = getOptId(f.supplier);
    const fromDate = isoOrUndefined(f.fromDate);
    const toDate = isoOrUndefined(f.toDate);

    const isReturnOnly = f.transTypeId === RETURN_ONLY_TRIGGER;

    const baseRequest = {
      pageIndex: 0,
      pageSize,
      sortBy,
      sortDir,
      froM_DATE: fromDate,
      tO_DATE: toDate,
      brancH_ID: branchId,
      supplieR_ID: supplierId,
      haS_DISCOUNT: f.hasDiscount?.value,
      vaT_MODE: f.vatMode?.value
    };

    if (isReturnOnly) {
      return cleanObject({
        ...baseRequest,
        onlY_RETURN: true
      });
    }

    return cleanObject({
      ...baseRequest,
      tranS_TYPE_ID: f.transTypeId
    });
  };

  const applyFilters = () => {
    const request = buildRequestFromFilters(filters);

    // حماية نهائية: إذا onlY_RETURN=true امنع tranS_TYPE_ID نهائيًا
    if ((request as any).onlY_RETURN === true) {
      delete (request as any).tranS_TYPE_ID;
    }

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: request as any }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  };

  const clearFilters = () => {
    setFilters(defaultFilters);

    dispatch(
      setReportRequest({
        reportKey: REPORT_KEY,
        request: cleanObject({
          pageIndex: 0,
          pageSize,
          sortBy,
          sortDir
        }) as any
      })
    );

    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  };

  const TotalsCards = () => {
    if (!meta) return null;

    const totalBeforeVat = metaNum((meta as any).total_TOTAL_BEFORE_VAT);
    const totalVat = metaNum((meta as any).total_VAT);
    const totalNet = metaNum((meta as any).total_NET_AMOUNT);
    const totalDIS = metaNum((meta as any).total_DISCOUNT);

    const hasAny = totalBeforeVat !== 0 || totalVat !== 0 || totalNet !== 0 || totalDIS !== 0;
    if (!hasAny && items.length === 0) return null;

    return (
      <div className='row g-3 mb-3'>
        <div className='col-lg-3 col-md-6'>
          <Card className='card bg-primary bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-receipt text-primary fa-xl'></i>
              </div>
              <div>
                <h6 className='text-primary fw-bold mb-1'>{isAr ? 'إجمالي قبل الضريبة' : 'Total Before VAT'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(totalBeforeVat)}</h4>
              </div>
            </div>
          </Card>
        </div>

        <div className='col-lg-3 col-md-6'>
          <Card className='card bg-warning bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-percent text-warning fa-xl'></i>
              </div>
              <div>
                <h6 className='text-warning fw-bold mb-1'>{isAr ? 'إجمالي الضريبة' : 'Total VAT'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(totalVat)}</h4>
              </div>
            </div>
          </Card>
        </div>

        <div className='col-lg-3 col-md-6'>
          <Card className='card bg-success bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-coins text-success fa-xl'></i>
              </div>
              <div>
                <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي الصافي' : 'Total Net Amount'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(totalNet)}</h4>
              </div>
            </div>
          </Card>
        </div>

        <div className='col-lg-3 col-md-6'>
          <Card className='card bg-danger bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-tags text-danger fa-xl'></i>
              </div>
              <div>
                <h6 className='text-danger fw-bold mb-1'>{isAr ? 'إجمالي الخصومات' : 'Total Discount'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(totalDIS)}</h4>
              </div>
            </div>
          </Card>
        </div>
      </div>
    );
  };

  const totalsFooter = useMemo(() => {
    return items.reduce(
      (acc, r) => {
        acc.totalBeforeVat += r.totaL_BEFORE_VAT || 0;
        acc.totalDiscount += r.discounT_AMOUNT || 0;
        acc.totalVat += r.vat || 0;
        acc.totalNet += r.neT_AMOUNT || 0;
        return acc;
      },
      { totalBeforeVat: 0, totalDiscount: 0, totalVat: 0, totalNet: 0 }
    );
  }, [items]);

  return (
    <>
      <CardHeader className='mb-3'>
        <div className='row g-2 align-items-center mb-2'>
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-store text-primary'></i>
              </span>
              <Select
                isLoading={loadingBranches}
                value={filters.branch}
                onChange={val => setFilter('branch', val)}
                options={OptionsBranches}
                placeholder={isAr ? 'الفرع' : 'Branch'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-truck text-danger'></i>
              </span>
              <Select
                isLoading={loadingSuppliers}
                value={filters.supplier}
                onChange={val => setFilter('supplier', val)}
                options={OptionsSuppliers}
                placeholder={isAr ? 'المورد' : 'Supplier'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={filters.fromDate}
                onChange={e => setFilter('fromDate', e.target.value)}
                placeholder={isAr ? 'من تاريخ' : 'From Date'}
              />
            </div>
          </div>

          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={filters.toDate}
                onChange={e => setFilter('toDate', e.target.value)}
                min={filters.fromDate || undefined}
                placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
              />
            </div>
          </div>

          <div className='col-lg-2 text-end'>
            <button
              className='btn btn-outline-secondary me-2'
              type='button'
              onClick={clearFilters}
              title={t('ClearFilters')}
            >
              <i className='fas fa-times fa-fw'></i>
            </button>

            <button className='btn btn-theme me-2' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
              <i className='fas fa-filter fa-fw'></i>
            </button>

            <button
              className='btn btn-outline-success'
              type='button'
              onClick={() => setShowExport(true)}
              title={t('Export')}
              disabled={loading || items.length === 0}
            >
              <i className='fas fa-file-excel fa-fw'></i>
            </button>
          </div>
        </div>

        <div className='row g-2 align-items-center'>
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-tags text-warning'></i>
              </span>
              <Select
                value={optionsTransType.find(f => f.value === filters.transTypeId) || null}
                options={optionsTransType}
                onChange={(op: any) => setFilter('transTypeId', op?.value ?? null)}
                placeholder={isAr ? 'نوع الحركة' : 'Trans Type'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-percent text-danger'></i>
              </span>
              <Select
                value={filters.hasDiscount}
                onChange={(op: any) => setFilter('hasDiscount', op ?? null)}
                options={[
                  { value: true, label: isAr ? 'يوجد خصم' : 'Has Discount' },
                  { value: false, label: isAr ? 'لا يوجد خصم' : 'No Discount' }
                ]}
                placeholder={isAr ? 'حالة الخصم (الكل)' : 'Discount Status (All)'}
                isClearable
                isSearchable={false}
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-file-invoice-dollar text-primary'></i>
              </span>
              <Select
                value={filters.vatMode}
                onChange={(op: any) => setFilter('vatMode', op ?? null)}
                options={[
                  { value: true, label: isAr ? 'ضريبية' : 'With VAT' },
                  { value: false, label: isAr ? 'غير ضريبية' : 'Without VAT' }
                ]}
                placeholder={isAr ? 'حالة الضريبة (الكل)' : 'VAT Mode (All)'}
                isClearable
                isSearchable={false}
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>
        </div>
      </CardHeader>

      <TotalsCards />

      <Card className='mb-4'>
        <Loading loading={loading} error={error}>
          <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
            <table className='table table-hover table-bordered mb-0'>
              <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
                <tr className='bg-theme bg-opacity-35 text-center' style={{ backdropFilter: 'blur(20px)' }}>
                  <th className='small text-primary' colSpan={4}>
                    {isAr ? 'بيانات العملية' : 'Transaction Info'}
                  </th>
                  <th className='small text-success' colSpan={4}>
                    {isAr ? 'المبالغ' : 'Amounts'}
                  </th>
                </tr>

                <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
                  <th className='small' style={{ minWidth: 130 }}>
                    {t('Date')}
                  </th>
                  <th className='small' style={{ minWidth: 160 }}>
                    {isAr ? 'الكود' : 'Code'}
                  </th>
                  <th className='small' style={{ minWidth: 170 }}>
                    {isAr ? 'الفرع' : 'Branch'}
                  </th>
                  <th className='small' style={{ minWidth: 220 }}>
                    {isAr ? 'المورد' : 'Supplier'}
                  </th>
                  <th className='small text-end' style={{ minWidth: 120 }}>
                    {isAr ? 'قبل الضريبة' : 'Before VAT'}
                  </th>
                  <th className='small text-end' style={{ minWidth: 100 }}>
                    {isAr ? 'الخصم' : 'Discount'}
                  </th>
                  <th className='small text-end' style={{ minWidth: 110 }}>
                    {isAr ? 'الضريبة' : 'VAT'}
                  </th>
                  <th className='small text-end' style={{ minWidth: 120 }}>
                    {isAr ? 'الصافي' : 'Net Amount'}
                  </th>
                </tr>
              </thead>

              <tbody>
                {!loading && items.length > 0 ? (
                  items.map((r, idx) => {
                    const branchName = isAr ? r.brancH_NAME2 || r.brancH_NAME : r.brancH_NAME || r.brancH_NAME2;

                    return (
                      <tr key={`${r.transactioN_ID || idx}`} className='align-middle'>
                        <td className='text-center'>{formatDate(r.transactioN_DATE)}</td>

                        <td className='text-center'>
                          {(() => {
                            const linkUrl = getCodeLink(r.code, r.transactioN_ID);

                            return linkUrl ? (
                              <Link to={linkUrl} className='fw-bold text-primary text-decoration-none' target='_blank'>
                                {safe(r.code)}
                              </Link>
                            ) : (
                              <span className='fw-bold text-primary'>{safe(r.code)}</span>
                            );
                          })()}
                        </td>

                        <td className='text-start'>{safe(branchName)}</td>

                        <td className='text-start'>
                          <span className='fw-bold'>{safe(r.supP_NAME)}</span>
                          <br />
                          {safe(r.vaT_CODE)}
                        </td>

                        <td className='text-end fw-bold'>{formatNumber(r.totaL_BEFORE_VAT)}</td>
                        <td className='text-end fw-bold text-danger'>{formatNumber(r.discounT_AMOUNT)}</td>
                        <td className='text-end fw-bold text-warning'>{formatNumber(r.vat)}</td>
                        <td className='text-end fw-bold text-success'>{formatNumber(r.neT_AMOUNT)}</td>
                      </tr>
                    );
                  })
                ) : !loading ? (
                  <tr>
                    <td colSpan={8} className='text-center py-5'>
                      <div className='text-muted'>
                        <i className='fas fa-file-invoice fa-3x mb-3 opacity-50'></i>
                        <h6>{t('NoData')}</h6>
                      </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>

              {!loading && items.length > 0 && (
                <tfoot className='fw-bold bg-secondary bg-opacity-30'>
                  <tr>
                    <td colSpan={4} className='text-end'>
                      <span className='h6 m-0'>{isAr ? 'الإجمالي (الصفحة):' : 'Totals (page):'}</span>
                    </td>
                    <td className='text-end'>
                      <span className='h6 m-0'>{formatNumber(totalsFooter.totalBeforeVat)}</span>
                    </td>
                    <td className='text-end text-danger'>
                      <span className='h6 m-0'>{formatNumber(totalsFooter.totalDiscount)}</span>
                    </td>
                    <td className='text-end text-warning'>
                      <span className='h6 m-0'>{formatNumber(totalsFooter.totalVat)}</span>
                    </td>
                    <td className='text-end text-success'>
                      <span className='h6 m-0'>{formatNumber(totalsFooter.totalNet)}</span>
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
            <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <ReportExportExcelModal
        show={showExport}
        onHide={() => setShowExport(false)}
        reportKey={REPORT_KEY}
        endpoint={ENDPOINT}
        columns={exportColumns}
        exportPageSize={4000}
        sheetName={({ isAr }) => (isAr ? 'تفاصيل المشتريات' : 'Purchase Details')}
        fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
      />
    </>
  );
};

export default PurchaseDetails_Paged;